import { render } from "./getToken.vue?vue&type=template&id=7c6d7b89&scoped=true"
import script from "./getToken.vue?vue&type=script&lang=js"
export * from "./getToken.vue?vue&type=script&lang=js"

import "./getToken.vue?vue&type=style&index=0&id=7c6d7b89&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/spinwheel-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6d7b89"]])

export default __exports__